'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.dayAgo;


// WEBPACK FOOTER //
// ./~/sugar-date/number/dayAgo.js